<header class="score-board__header">
  <h1 class="score-board__title">
    {{ 'LECTURES.PROGRESS.LEADER_BOARD' | translate }}
  </h1>
  <div class="badge score-board__badge">
    {{ 'LECTURES.PROGRESS.PLACE' | translate }} :  {{ currentPlace }}
  </div>
  <button type="button" class="btn score-board__x-btn" (click)="closeModal()"></button>
</header>

<main class="score-board__main px-sm-2 px-md-5 py-3">
  <div id="leaders" class="w-100 justify-content-center">
    <div class="grid-margin stretch-card">
      <div class="table-responsive">
        <div *ngIf="!isLoading; else loader" class="score-board__table table">
          <span class="score-board__table-head pb-3">
            <span class="row score-board__table-row score-board__table-head" [ngClass]="[ lang ? lang : '']">
              <span class="col-1 th">#</span>
              <span class="col-2 th">{{'LECTURES.DASHBOARD.TOP_LECTURERS_NAME' | translate}}</span>
              <span class="col-5 th num"></span>
              <span class="col-2 th num">{{'LECTURES.DASHBOARD.TOP_LECTURERS_LECTS' | translate}}</span>
              <span class="col-2 th num">{{'LECTURES.DASHBOARD.TOP_LECTURERS_PARTICIPANTS' | translate}}</span>
            </span>
          </span>
          <span class="score-board__table-row">
            <span *ngFor="let u of allUsersMeta; let i = index" class="row score-board__table-row leaders-table"
              [ngClass]="[isCurrentUser(u.email) ? 'current' : '', lang ? lang : '']">
              <span class="col-1">{{ i + 1 }}</span>
              <span class="col-2"><img appGravatar [user]="u" alt="profile" class="profile"/></span>
              <span class="col-5 num">{{ u.firstName + ' ' + u.lastName}}</span>
              <span class="col-2 num">{{ u.progress?.numOfCompleted}}</span>
              <span class="col-2 num">{{ u.progress?.numOfParticipants}}</span>
            </span>
          </span>
        </div>
        <ng-template #loader>
          <span class="loader">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgba(255, 255, 255, 0); display: block; shape-rendering: auto;" width="64px" height="64px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#ffffff" stroke="none">
                  <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
                </path>
            </svg>
          </span>
        </ng-template>
      </div>
    </div>
  </div>
</main>

<footer class="score-board__footer">
  <button type="button" class="btn btn-primary score-board__close-btn" (click)="closeModal()">{{ 'LECTURES.PROGRESS.CLOSE' | translate }}</button>
</footer>
